import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldWrapper } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { QuillModule } from 'ngx-quill';
import { Observable } from 'rxjs';
import { FilterOptionsPipe } from 'src/app/pipes/filter.pipe';

@Component({
  selector: 'app-common-label-wrapper',
  template: `
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-4 input-wrappers">
    <form [formGroup]="phoneForm">
      <div>
        <label>
          <mat-label for="email">
            <span class="mat-label">
              <em *ngIf="to.labelIcon" class="fa {{to.labelIcon || ''}}"></em> {{ to.label }}
              <span class="required-icon">*</span>
            </span>
            <mat-icon *ngIf="to['tooltip']" matTooltip="{{ to['tooltip'] }}" class="tooltip-icon" matTooltipPosition="right">
              help
            </mat-icon>
          </mat-label>
        </label>
      </div>
   
      <div class="phone-form-input">
        <mat-form-field class="country-code-field" floatLabel="always">
          <mat-select
            id="{{field.key}}"
            placeholder="Select Country Code"
            [attr.disabled]="getDisable()" (selectionChange)="updateFormValues()"
            formControlName="countryCode">
            <mat-option>
              <ngx-mat-select-search [placeholderLabel]="'search' | translate" noEntriesFoundLabel="'No data found'" #searchCode></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let option of phoneCodes | filterOptions: searchCode.value : 'code'" [value]="option.dial_code">
              {{ option.code }} ({{ option.dial_code }})
            </mat-option>
          </mat-select>
        </mat-form-field>
   
        <mat-form-field class="phone-number-field" for="phoneNumber" floatLabel="always">
          <input
            matInput
            placeholder="Enter Phone Number"
            formControlName="phoneNumber"
            (keypress)="numberOnly($event)"
            id="{{field.key}}"
            [attr.disabled]="getDisable()"
            (input)="updateFormValues()"
            aria-describedby="phoneNumber"
          />
         
        </mat-form-field>
      </div>
   
      <div *ngIf="showError" class="error mt-1">
        <ng-container *ngIf="phoneForm.controls.countryCode?.errors; else checkPhoneNumber">
          <div *ngIf="phoneForm.controls.countryCode?.hasError('required')">Country Code is required</div>
        </ng-container>
   
        <ng-template #checkPhoneNumber>
          <ng-container *ngIf="phoneForm.controls.phoneNumber?.errors">
            <div *ngIf="phoneForm.controls.phoneNumber?.hasError('required')">Phone Number is required</div>
            <div *ngIf="phoneForm.controls.phoneNumber?.hasError('pattern')">Enter a valid phone number.</div>
          </ng-container>
        </ng-template>
      </div>
    </form>
  </div>
   
    `,
    styles: [
      `
      .error{
    color:red !important;
    font-size: 11px !important;
      }
      .margin{
        margin-top:10px;
      }
        input {
          border-top-right-radius: 5px !important;
          border-bottom-right-radius: 5px !important;
        }
        .error-message{
          color: #f44336;
          font-size: 11px;
        }
  .mat-label{
    font-family:Poppins, sans-serif !important;
    font-size:14px !important;
  }
        .tooltip-icon{
          font-size: 14px;
        }
        .error-message{
          padding: 6px !important;
        }
        :host ::ng-deep .input-wrappers .mat-mdc-form-field-infix {
    padding-top: 0px !important;
    padding-bottom: 4px !important;
  }
   
  ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-ripple {
    overflow: inherit !important;
  }
   
  .select-all {
    margin: 5px;
  }
   
  .margin-top-6px {
    margin-top: 6px;
  }
   
  .option-no-Data ::ng-deep .mat-pseudo-checkbox-disabled {
    display: none !important;
  }
   
  ::ng-deep .mat-mdc-radio-button .mdc-radio {
    padding: 5px !important;
  }
   
  form .mat-mdc-form-field {
    margin-top: 0px !important;
  }
   
  .mat-mdc-form-field-subscript-wrapper {
    line-height: 0px !important;
  }
   
   
   
      `,
    ],
  standalone:true,
  imports:[
    NgbTooltipModule,
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatTooltipModule,
    QuillModule,
    MatFormFieldModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatetimepickerModule,
    NgxMatSelectSearchModule,
    FormlyMaterialModule,
    MatSelectModule,
    TranslateModule,
    FilterOptionsPipe,
  ]
})
export class CommonLabelWrapperComponent extends FieldWrapper implements OnInit {
  phoneForm!: FormGroup; // FormGroup to hold phoneNumber and countryCode
  phoneCodes$!: Observable<any>;
  phoneCodes: any;
 
  constructor(
    private httpClient: HttpClient,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder // Inject FormBuilder to create FormGroup
  ) {
    super();
  }
 
  getDisable(): any {
    return this.field.props?.readOnly ? true : null;
  }
 
  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
 
  ngOnInit() {
    // Initialize FormGroup
    this.phoneForm = this.fb.group({
      countryCode: ['', Validators.required],
      phoneNumber: ['', Validators.required],
    });
 
    // Load phone codes
    this.phoneCodes$ = this.httpClient.get('assets/phoneCode.json');
    this.getphcodes();
 
    let isRequired = this.field?.templateOptions?.required;
    if (isRequired) {
      if (this.field?.formControl) {
        this.field.formControl.statusChanges.subscribe((status) => {
          if (this.field.formControl.touched) {
            this.cdr.detectChanges();
          }
        });
      }
    }
 
    setTimeout(() => {
      if (this.field?.defaultValue) {
        if (typeof this.field.defaultValue !== 'object') {
          const phoneNumberString = this.field?.defaultValue;
 
          if (phoneNumberString) {
            let parts = phoneNumberString?.split(' - ');
            parts[1] = parts[1].replace(/\s/g, '');
            this.phoneForm.get('countryCode')?.patchValue(parts[0]);
            this.phoneForm.get('phoneNumber')?.patchValue(parts[1]);
          }
        }
      }
    }, 1000);
 
    // Subscribe to country code changes
    this.phoneForm.controls.countryCode.valueChanges.subscribe((value) => {
      const pattern = this.getPatternForCountry(value);
      this.phoneForm.get('phoneNumber')?.setValidators([Validators.required, Validators.pattern(pattern)]);
      this.phoneForm.get('phoneNumber')?.updateValueAndValidity();
    });
  }
  updateFormValues() {
    const countryCodeValue = this.phoneForm.get('countryCode')?.value;
    let phoneNumberValue = this.phoneForm.get('phoneNumber')?.value;
    const finalVal = countryCodeValue  + ' - ' + phoneNumberValue
 
    // Update the form field values
 
 
    if (countryCodeValue == '' || countryCodeValue == null || countryCodeValue == undefined || this.phoneForm.get('phoneNumber')?.invalid) {
      phoneNumberValue = null;
      this.field.formControl?.setValue(phoneNumberValue);
      this.field.defaultValue = phoneNumberValue
      this.phoneForm.get('phoneNumber')?.setErrors({ 'invalid': true }); // Set the 'invalid' error
      this.phoneForm.get('phoneNumber')?.updateValueAndValidity();
    } else {
      if (this.phoneForm.get('phoneNumber')?.valid) {
        this.field.formControl?.setValue(finalVal);
        this.field.templateOptions?.customControl?.setValue(finalVal);
        this.field.defaultValue = finalVal
      } else {
        this.phoneForm.get('phoneNumber')?.setErrors({ 'invalid': true }); // Set the 'invalid' error
        this.phoneForm.get('phoneNumber')?.updateValueAndValidity();
      }
    }
  }
  // updateFormValues() {
  //   const countryCodeValue = this.phoneForm.controls.countryCode.value;
  //   let phoneNumberValue = this.phoneForm.controls.phoneNumber.value;
  //   const finalVal = `${countryCodeValue} - ${phoneNumberValue}`;
 
  //   // Update the form field values
  //   if (countryCodeValue == '' || countryCodeValue == null || countryCodeValue == undefined || this.phoneForm.controls.phoneNumber.invalid) {
  //     phoneNumberValue = null;
  //     this.field.formControl?.patchValue(phoneNumberValue);
  //     this.field.defaultValue = phoneNumberValue;
  //     this.phoneForm.controls.phoneNumber.setErrors({ invalid: true }); // Set the 'invalid' error
  //     this.phoneForm.controls.phoneNumber.updateValueAndValidity();
  //   } else {
  //     if (this.phoneForm.controls.phoneNumber.valid) {
  //       this.field.formControl?.patchValue(finalVal);
  //       this.field.defaultValue = finalVal;
  //     } else {
  //       this.phoneForm.controls.phoneNumber.setErrors({ invalid: true }); // Set the 'invalid' error
  //       this.phoneForm.controls.phoneNumber.updateValueAndValidity();
  //     }
  //   }
  // }
 
  getphcodes() {
    this.httpClient.get('assets/phoneCode.json').subscribe((data) => {
      this.phoneCodes = data;
    });
  }
 
  private getPatternForCountry(countryCode: any) {
    const selectedCountry = this.phoneCodes.find((option: any) => option.dial_code === countryCode);
    return selectedCountry ? selectedCountry.pattern : '\\d*'; // Default pattern if not found
  }
}
